/** @jsx jsx */

import { useState, useContext } from 'react';
import { css, jsx } from '@emotion/core';
import { values, colors } from 'styles/variables';
import setCurrentBlock from 'services/apiHelpers/setCurrentBlock';
import Plus from 'assets/Plus.svg';
import getCurrentTopic from 'services/apiHelpers/getCurrentTopic';
import getBlockById from 'services/apiHelpers/getBlockById';
import { Block } from '@chameleoncreator/creator-app';
import createInteraction from 'components/Editor/NewSectionWizard/createInteraction';
import { useSelector, useDispatch } from 'react-redux';
import { setBlockAction } from 'actions/setBlockAction';
import { setBlocksAction } from 'actions/setBlocksAction';
import { State } from 'store/store';
import preview from 'assets/previewInteractionIcon.svg';
//preview_interaction.svg';
import pubSub from 'services/pubSub';
import reviewToolReviewsBubble from 'assets/reviewToolReviewsBubble.svg';
import { Bubble } from 'components/Editor/EditorUtilities/UI/Bubble';

const { lPink, mint } = colors;
// const { headerHeight } = values;

const color = mint || lPink;
const size = 40;
const bottomPadding = 30;
const getBoxShadow = hover =>
  `box-shadow: 0 3px 10px rgba(0, 0, 0, ${hover ? 0.25 : 0});`;

const Wrapper = ({ id, focusedNodeId, headerHeight = 70 }) => {
  const [reviewToolToggleOn, setReviewToolToggleOn] = useState<boolean>(false);
  const [hover, setHover] = useState(false);

  const topic = getCurrentTopic() as any;
  const topicAsAssessment = topic?.props?.asAssessment;

  const state = useSelector((state: State) => {
    return state;
  });

  const [infoBubble, setInfoBubble] = useState<{
    element: HTMLElement;
    content: string;
  } | null>();

  const dispatch = useDispatch();

  const setBlock = block => {
    dispatch(setBlockAction(block));
  };
  const setBlocks = blocks => dispatch(setBlocksAction(blocks));

  return (
    <div
      css={css`
        position: absolute;
        left: 0px;
        top: 0px;
        width: 100%;
        height: 100%;
        padding: ${headerHeight + 3}px 3px ${bottomPadding}px 3px;
        pointer-events: none;

        * {
          font-family: 'Poppins';
        }
      `}
    >
      <div
        css={css`
          width: 100%;
          height: 100%;
          box-shadow: 0 0 0 1px
            ${focusedNodeId === id ? color : hover ? color : 'lightGrey'};
          transition: box-shadow 0.25s;
        `}
      />

      {!topicAsAssessment && (
        <div
          css={css`
          position: absolute;
          left: 50%;
          bottom: ${bottomPadding - size / 2}px;
          width: ${size}px;
          height: ${size}px;
          transform: translateX(-50%);
          border-radius: 50%;
          background: ${color} url('${Plus}') no-repeat;
        
          background-size: 40%;
          background-position: center;
          cursor: pointer;
          pointer-events: auto;

          transition: all 0.3s;

          ${getBoxShadow(false)}

          &:hover {
            ${getBoxShadow(true)}
          }
        
        `}
          onClick={() => {
            if (topicAsAssessment) {
              const topicAnimationGroup = getBlockById(
                topic.children[0].id
              ) as Block;
              if (topicAnimationGroup && topicAnimationGroup.children) {
                const numQuestions = topicAnimationGroup.children.length - 2;

                createInteraction({
                  blocks: state.blocks,
                  topic,
                  containerProperties: {},
                  interactionProperties: {
                    type: 'assessment question',
                    name: `Question #${numQuestions + 1}`,
                    layout: null,
                  },
                  setBlocks,
                  setBlock,
                });
              }

              return;
            }

            parent.setNewSectionWizard && parent.setNewSectionWizard(true);
          }}
          // onMouseEnter={e => {
          //   setInfoBubble({
          //     element: e.currentTarget,
          //     content: 'Add new interaction',
          //   });
          // }}
          // onMouseLeave={e => {
          //   setInfoBubble(null);
          // }}

          data-info-bubble="Add new interaction"
        />
      )}

      <div
        css={css`
          position: absolute;
          display: flex;
          justify-content: center;
          align-items: center;
          right: ${175 / 2}px;
          bottom: ${bottomPadding - size / 2}px;
          width: 175px;
          height: ${size}px;

          border-radius: 9999px;
          background: ${color};

          cursor: pointer;
          pointer-events: auto;

          color: #fff;
          font-size: 14px;
          transition: all 0.3s;

          ${getBoxShadow(false)}

          &:hover {
            ${getBoxShadow(true)}
          }
        `}
        onMouseOver={() => setHover(true)}
        onMouseOut={() => setHover(false)}
        onClick={() => {
          setCurrentBlock(focusedNodeId !== id ? { id } : null);
        }}
      >
        Settings
      </div>

      <button
        css={css({
          all: 'unset',
          //
          position: 'absolute',
          right: 25,
          bottom: 10,

          width: size,
          height: size,
          background: `${mint} url(${preview}) no-repeat`,
          // backgroundSize: `44%`,
          backgroundSize: '100%',
          backgroundPosition: 'center',
          borderRadius: '50%',
          cursor: 'pointer',
          pointerEvents: 'auto',

          transition: 'all 0.3s',

          boxShadow: `0 3px 10px rgba(0, 0, 0, 0)`,
          ':hover': {
            boxShadow: `0 3px 10px rgba(0, 0, 0, 0.25)`,
          },
        })}
        onClick={() => {
          //

          if (state.currentTopic && state.currentInteraction) {
            const topicSId = state.blocks[state.currentTopic]?.props?.sId;
            const currentInteractionSId =
              state.blocks[state.currentInteraction]?.props?.sId;

            const previewLocation = `#${topicSId}/${currentInteractionSId}`;

            const { links } = state;
            const previewLink = links.preview;
            const newWindowUrl = previewLink ? `${previewLink}` : `module.html`;
            //
            window.open(`${newWindowUrl}${previewLocation}`, 'preview');
          }
        }}
        // onMouseEnter={e => {
        //   setInfoBubble({
        //     element: e.currentTarget,
        //     content: 'Preview this interaction',
        //   });
        // }}
        // onMouseLeave={e => {
        //   setInfoBubble(null);
        // }}

        data-info-bubble="Preview this interaction"
      />

      {window.reviewModeEnabled && !reviewToolToggleOn && (
        <button
          className="fader_-2s"
          css={css({
            all: 'unset',
            //
            position: 'absolute',
            left: 25,
            bottom: 10,
            width: size,
            height: size,
            background: `#F88198 url('${reviewToolReviewsBubble}')no-repeat`,
            backgroundSize: '50%',
            backgroundPosition: 'center',
            borderRadius: '50%',
            cursor: 'pointer',
            pointerEvents: 'auto',
            transition: 'all 0.3s',

            boxShadow: `0 3px 10px rgba(0, 0, 0, 0)`,
            ':hover': {
              boxShadow: `0 3px 10px rgba(0, 0, 0, 0.25)`,
            },
          })}
          onClick={() => {
            const pS = pubSub.publish('SHOW_REVIEW_TOOL', {
              showReviewTool: true,
              setReviewToolToggleOff() {
                setReviewToolToggleOn(false);
              },
            });

            setReviewToolToggleOn(true);
          }}
        />
      )}
    </div>
  );
};

export default Wrapper;
